<template>
  <div
    class="button-group-header"
    :class="{ 'dark-mode': darkMode, }"
  >
    <ButtonGroup>
      <ButtonClassic
        id="bouton_panier"
        v-tooltip="{
          content: $tc(
            'panier.x-selection-dans-panier',
            quantiteLigne,
            { selection: quantiteLigne, }
          ),
          placement: 'bottom',
          delay: { show: 800, },
        }"
        variant="solid"
        color="secondary"
        size="medium"
        @click="$router.push({ name: 'panier', })"
      >
        <IconPanier
          height="16"
          width="16"
        />
        <Counter
          v-if="quantiteLigne > 0"
          :value="spaceNumber(quantiteLigne)"
          size="small"
        />
      </ButtonClassic>
    </ButtonGroup>
  </div>
</template>

<script>
import {
  ButtonClassic,
  ButtonGroup,
  Counter,
  spaceNumber,
} from "@lde/core_lde_vue";

import IconPanier from "@/components/icons/IconPanier.vue";

import { mapGetters } from "vuex";

/**
 * Groupe de boutons dans la topbar.
 */
export default {
  name: "ButtonGroupHeader",
  components: {
    ButtonGroup,
    ButtonClassic,
    Counter,
    IconPanier,
  },
  props: {
    /**
     * La couleur de fond du parent est sombre.
     */
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPopoverOpen: false,
      listName: "",
    };
  },
  computed: {
    ...mapGetters([
      "panier",
      "quantiteLigne"
    ]),
    isTotalInBar: {
      get() {
        return this.preferences?.totalInBar;
      },
      set(totalInBar) {
        this.$store.commit("updatePreferences", { totalInBar });
      },
    },
    tooltipTitle() {
      if (this.panier) {
        return this.$tc("selection.x-selection-en-cours", spaceNumber(this.quantiteLigne),
          { selection: spaceNumber(this.quantiteLigne) });
      }
      return this.$t("selection.aucune-liste-selectionnee");
    },
  },
  methods: {
    spaceNumber,
  },
};
</script>

<style lang="scss">
@use "@/assets/styles/components/buttons/button_group_header.scss";
</style>
